import { defineStore } from 'pinia';

import * as state from './meeting.state';
import * as getters from './meeting.getters';
import * as actions from './meeting.actions';

export const useMeetingStore = defineStore('meeting', () => ({
  ...state,
  ...getters,
  ...actions
}));

